// React
import React, {useContext, useState} from 'react'

// Third-party
import {Modal} from 'react-bootstrap'
import {toast} from 'react-toastify'

// Styles
import classes from './AgreementModal.module.css'

// App
import SanctumContext from '../../Sanctum/SanctumContext'
import {errorHandler} from '../../utils'

type Props = {
    show: boolean
    onAccept: () => void
}

const AgreementModal: React.FC<Props> = ({show, onAccept}) => {
    const {acceptAgreement, signOut} = useContext(SanctumContext)
    const [isLoading, setIsLoading] = useState(false)

    const handleAccept = () => {
        if (acceptAgreement) {
            setIsLoading(true)
            acceptAgreement()
                .then(() => {
                    toast.success('Согласие принято')
                    onAccept()
                })
                .catch((error) => {
                    errorHandler(error)
                })
                .finally(() => {
                    setIsLoading(false)
                })
        }
    }

    const handleClose = () => {
        if (signOut) {
            signOut()
        }
    }

    return (
        <Modal
            show={show}
            onHide={() => handleClose()}
            backdrop="static"
            keyboard={false}
            centered
            size="lg"
            className={classes.agreementModal}
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    <h4 className="h4">Согласие на обработку данных</h4>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className={classes.body}>
                <p className={classes.text}>
                    Ознакомлен с{' '}
                    <a
                        className={classes.link}
                        target='_blank'
                        rel='noreferrer'
                        href={`${process.env.REACT_APP_MAIN_PAGE || ''}/policy`}
                    >
                        внутренними правилами сайта
                    </a>
                    , Согласен на обработку персональных данных
                </p>
                <button
                    className={classes.submitBtn}
                    onClick={handleAccept}
                    disabled={isLoading}
                >
                    {isLoading ? 'Подтверждение...' : 'Подтвердить'}
                </button>
            </Modal.Body>
        </Modal>
    )
}

export default AgreementModal
